import axios from 'axios'
import Config from './app.config.js'
import logService from './services/log.service'
import httpService from './services/http.service.js'
import store from 'src/vuex/store'

axios.defaults.baseURL = Config.apiDomain
let axiosConfig = { withCredentials: true }

const setHeaders = () => {
  const token = store.getters['tokens/accessToken']
  if (token) {
    axiosConfig.headers = {
      Authorization: 'Bearer ' + token,
    }
  } else {
    axiosConfig = { withCredentials: true }
  }
}

const handleError = err => {
  logService.log(err)
  if (_.get(err, 'response.status') === 401) {
    if (store.getters.isLoggedIn) {
      store.dispatch('clearCurrentUser')
    } else {
      store.dispatch('showModal', 'login')
    }
  }
  return err
}

const dataService = {
  get(path) {
    setHeaders()
    return new Promise((resolve, reject) => {
      axios
        .get(path, axiosConfig)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const error = handleError(err)
          if (error) {
            reject(err)
          }
        })
    })
  },
  post(path, data) {
    setHeaders()
    return new Promise((resolve, reject) => {
      axios
        .post(path, data, axiosConfig)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const error = handleError(err)
          if (error) {
            reject(err)
          }
        })
    })
  },
  delete(path) {
    setHeaders()
    return new Promise((resolve, reject) => {
      axios
        .delete(path, axiosConfig)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const error = handleError(err)
          if (error) {
            reject(err)
          }
        })
    })
  },
  patch(path, data) {
    setHeaders()
    return new Promise((resolve, reject) => {
      axios
        .patch(path, data, axiosConfig)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const error = handleError(err)
          if (error) {
            reject(err)
          }
        })
    })
  },
  put(path, data) {
    setHeaders()
    return new Promise((resolve, reject) => {
      axios
        .put(path, data, axiosConfig)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const error = handleError(err)
          if (error) {
            reject(err)
          }
        })
    })
  },

  /********************************************************
   * No confidence in methods below,
   * they are stored for back compatibility at the moment
   *********************************************************/
  cacheRequest(path, cacheTime) {
    return new Promise((resolve, reject) => {
      httpService
        .get(path, cacheTime)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          logService.log(err)
          reject(err)
        })
    })
  },
  getLocal(id) {
    return new Promise((resolve, reject) => {
      httpService
        .getLocal(id)
        .then(response => resolve(response.data))
        .catch(err => {
          logService.log(err)
          reject(err)
        })
    })
  },
  setLocal(id, value) {
    return new Promise((resolve, reject) => {
      httpService
        .setLocal(id, Config.caching.local, value)
        .then(response => resolve(response.data))
        .catch(err => {
          logService.log(err)
          reject(err)
        })
    })
  },
  getData(path) {
    return new Promise((resolve, reject) => {
      this.cacheRequest(`${path}`, Config.caching.api)
        .then(response => resolve(response.data))
        .catch(err => {
          logService.log(err)
          reject(err)
        })
    })
  },
}

export default dataService
